import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';

import {
  onClearFilters,
  setCredentialSearchTerm,
  setShowCredentialModal,
} from './credential.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

export function CredentialRouteActions() {
  const dispatch = useAppDispatch();
  const {
    credentialSearchTerm,
    selectedCredentialTypes,
    selectedMembers,
    selectedVehicles,
  } = useAppSelector((state) => state.credential);

  const showClearFiltersButton = !!(
    selectedCredentialTypes.length ||
    selectedMembers.length ||
    selectedVehicles.length
  );

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setCredentialSearchTerm,
    credentialSearchTerm
  );

  return (
    <>
      {showClearFiltersButton && (
        <Button
          onClick={() => {
            dispatch(onClearFilters());
          }}
          variant="anchor"
          dataTestId="clear-credential-filters-button"
        >
          clear filters
        </Button>
      )}
      <SearchTypeahead
        onChange={handleInputChange}
        placeholder="Search credentials"
        value={inputValue}
      />

      <Button
        onClick={() => {
          dispatch(setShowCredentialModal(true));
        }}
        variant="primary"
        dataTestId="add-credential-button"
      >
        Add Credential
      </Button>
    </>
  );
}
